import { render, staticRenderFns } from "./support-section-faq.vue?vue&type=template&id=38a9eb54"
import script from "./support-section-faq.vue?vue&type=script&lang=js"
export * from "./support-section-faq.vue?vue&type=script&lang=js"
import style0 from "./support-section-faq.vue?vue&type=style&index=0&id=38a9eb54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports